module.exports = __webpack_public_path__ + "img/189-64b755.png";